// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHMOBXN5rX3U3Xggg_ldibDOYzjwGVI1w",
  authDomain: "ai-home-e3aa9.firebaseapp.com",
  projectId: "ai-home-e3aa9",
  storageBucket: "ai-home-e3aa9.firebasestorage.app",
  messagingSenderId: "546265567926",
  appId: "1:546265567926:web:5589db37634c5a1acf0c17",
  measurementId: "G-R0GMMP90GL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, analytics, db, storage };

